import { render, staticRenderFns } from "./StoreBlock.vue?vue&type=template&id=3d1fb1f4&lang=pug&"
import script from "./StoreBlock.vue?vue&type=script&lang=js&"
export * from "./StoreBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports